import { useTranslation } from 'react-i18next';
import { useAppSettingsStore, useMediaQuery } from '@/shared/lib';
import { AppLinkButton } from '@/shared/components';
import GooglePlayIcon from '@/shared/assets/google-play.svg?react';
import HuaweiStoreIcon from '@/shared/assets/huawei-store.svg?react';
import GlobeIcon from '@/shared/assets/globe-icon.svg?react';
import { tv } from 'tailwind-variants';

const classes = tv({
  slots: {
    marketBtn: 'w-[calc(50%-1.2rem/2)] md:w-full',
    webAppBtn: 'w-full md:w-full',
  },
});

const MobileAppImage = ({ lang }: { lang: 'ru' | 'en' }) => (
  <img
    src={`/assets/mobile-img-${lang}.png`}
    className="w-full max-w-[28.9rem] block md:hidden lg:block mt-[1rem] md:mt-0 lg:ml-[5.8rem] mx-auto md:mx-0"
    alt="Mobile App"
  />
);

const UnauthorizedLayoutMobileAppCTA = () => {
  const { t } = useTranslation();
  const { language } = useAppSettingsStore();
  const locale = language === 'ru' ? 'ru' : 'en';
  const c = classes();
  const isMobile = useMediaQuery('(max-width: 768px)');

  const AppImage = () => <MobileAppImage lang={locale} />;

  return (
    <>
      {!isMobile && <AppImage />}
      <div className="flex flex-col gap-[3.2rem] overflow-hidden">
        <div className="flex flex-col gap-[0.8rem]">
          <h2 className="text-center headline0 text-balance md:mt-[2.4rem] lg:mt-0">
            {t('authPages.downloadAppBlock.title')}
          </h2>
          <p className="text-center p4 text-balance text-secondary">
            {t('authPages.downloadAppBlock.text')}
          </p>
        </div>

        <div className="flex flex-row flex-wrap md:flex-col justify-center md:items-start items-center gap-[1.2rem] md:gap-[3.2rem]">
          <img
            src="/assets/qr-code-to-app.svg"
            className="hidden md:block w-[22rem] h-[22rem] mx-auto"
            alt="QR-code to app"
          />
          <div className="flex flex-wrap gap-x-[1.2rem] gap-y-[1.6rem] w-full">
            <AppLinkButton
              appLink={`https://play.google.com/store/apps/details?id=com.free2ex.exchange.wallet.app&hl=${locale}`}
              icon={GooglePlayIcon}
              className={c.marketBtn()}
            />
            <AppLinkButton
              appLink={`https://appgallery.huawei.com/app/C111820493`}
              icon={HuaweiStoreIcon}
              label="AppGallery"
              iconClassName="size-10"
              className={c.marketBtn()}
            />
            <AppLinkButton
              appLink={`https://pwa.free2ex.com/`}
              icon={GlobeIcon}
              label="Web App"
              iconClassName="size-[2.4rem]"
              className={c.webAppBtn()}
            />
          </div>
        </div>

        {isMobile && <AppImage />}
      </div>
    </>
  );
};

export { UnauthorizedLayoutMobileAppCTA };
